var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxBxDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.33333L10 6.41666H8.125V2.33333H6.875V6.41666H5L7.5 9.33333Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.5H2.5V6.41667H1.25V10.5C1.25 11.1434 1.81063 11.6667 2.5 11.6667H12.5C13.1894 11.6667 13.75 11.1434 13.75 10.5V6.41667H12.5V10.5Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBxDownload);
export default __webpack_public_path__ + "static/media/bx_bx-download.03a75b55f0d64a858fa40e521f36e1fa.svg";
export { ForwardRef as ReactComponent };